// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';

import {ButtonTheme} from '../button/constants';
import type {Modal} from './index';

export function template(this: Modal) {
  const {visibility} = this.state;

  return (
    <div
      sel='.mp-modal'
      class={{
        'is-closed': this.helpers.isClosed(),
        'is-fullscreen': !this.attr(`not-fullscreen`),
        [`is-${this.attr(`modal-type`)}`]: true,
        'mp-modal-sliding': this.attr(`sliding-transition`),
      }}
    >
      {this.helpers.showBackdrop() ? (
        <div
          sel='.mp-modal-backdrop'
          class={{
            [`is-${visibility}`]: true,
          }}
          on={{
            mousedown: this.helpers.handleBackdropClick,
          }}
        />
      ) : null}
      <div
        sel='.mp-modal-wrapper'
        attrs={{
          elref: `contentBody`,
        }}
        class={{
          [`is-${this.attr(`modal-type`)}`]: true,
          [`is-${this.attr(`vertical-alignment`)}-aligned`]: true,
          [`is-${visibility}`]: true,
        }}
        on={{
          mousedown: this.helpers.handleBackdropClick,
        }}
      >
        <div
          sel='.mp-modal-main'
          class={{
            [`is-${this.attr(`modal-type`)}`]: true,
            'is-variable-width': this.attr(`grow-to-content`),
            'has-background': !this.attr(`hide-background`),
          }}
          attrs={{
            role: `dialog`,
            'aria-labelledby': this.attr(`modal-title`),
            'aria-describedby': this.attr(`modal-description`),
            'aria-modal': true,
          }}
          on={{
            mousedown: (ev) => ev.stopPropagation(),
          }}
        >
          {(this.attr(`closeable`) || this.attr(`modal-type`) === `tour-modal`) && !this.attr(`hide-close-button`) ? (
            <ButtonEl
              sel='.mp-modal-close-button'
              attrs={{
                elref: `closeModalButton`,
                theme: ButtonTheme.Tertiary,
                icon: `x`,
              }}
              class={{
                'close-button-padded': this.attr(`close-button-padded`),
              }}
              on={{
                click: this.helpers.handleCloseClick,
              }}
            />
          ) : null}
          {/*modal body*/}
          <slot />
        </div>
      </div>
    </div>
  );
}
